class ShortcutsService {
  get scoring() {
    return [
      {
        key: 'Space',
        description: 'Start/Stop Clock',
      },

      {
        key: 'Ctrl + ]',
        description: 'Skip to Latest Event',
      },

      {
        key: '[',
        description: 'Previous Event',
      },

      {
        key: ']',
        description: 'Next Event',
      },

      {
        key: 'Alt + Z',
        description: 'Open Timeline Zoom',
      },

      {
        key: '?',
        description: 'Open This Menu',
      },

      {
        key: '`',
        description: 'Flag Event (Available when Event Dialog is open)',
      },
    ]
  }
}

export default new ShortcutsService()
